var _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 11.6667L22.9627 14.1765L20.4238 11.6667M23.273 13.549C23.319 13.137 23.3427 12.7183 23.3427 12.2941C23.3427 6.05655 18.2292 1 11.9213 1C5.61351 1 0.5 6.05655 0.5 12.2941C0.5 12.6111 0.513202 12.925 0.539093 13.2353C0.681248 14.9392 1.20591 16.5359 2.02797 17.9412",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9219 6.02344C11.9219 8.47379 11.9219 12.2979 11.9219 12.2979L15.729 14.8078",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4135,
    cy: 19.5887,
    rx: 0.721154,
    ry: 0.705882,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.4907,
    cy: 21.4715,
    rx: 0.721154,
    ry: 0.705882,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.7592,
    cy: 24.2918,
    rx: 0.721154,
    ry: 0.705882,
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.95162,
    cy: 23.3543,
    rx: 0.721154,
    ry: 0.705882,
    fill: "black"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.06686,
    cy: 21.4715,
    rx: 0.721154,
    ry: 0.705882,
    fill: "black"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.6059,
    cy: 23.3543,
    rx: 0.721154,
    ry: 0.705882,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplit);
export default __webpack_public_path__ + "static/media/split.78780d968e321cda4a95cdda1507b1e2.svg";
export { ForwardRef as ReactComponent };